const apps = [
  {
    path: 'users',
    name: 'application.users',
    component: () => import(/* webpackChunkName: "apps" */ '../views/dashboard/app/users/Index.vue'),
    meta: {
      requiredAuth: true
    }
  },
  {
    path: 'clients/company',
    name: 'application.clients.company',
    component: () => import(/* webpackChunkName: "apps" */ '../views/dashboard/app/clients/companies/Index.vue'),
    meta: {
      requiredAuth: true
    }
  },
  {
    path: 'clients/type',
    name: 'application.clients.type',
    component: () => import(/* webpackChunkName: "apps" */ '../views/dashboard/app/clients/types/Index.vue'),
    meta: {
      requiredAuth: true
    }
  },
  {
    path: 'clients/logo',
    name: 'application.clients.logo',
    component: () => import(/* webpackChunkName: "apps" */ '../views/dashboard/app/clients/logo/Index.vue'),
    meta: {
      requiredAuth: true
    }
  }
]

export default apps
